import React from "react";
import Tooltip from "@mui/material/Tooltip";

import "./style.css";

interface QuestionHistoryDisplayProps {
    history: Array<any>;
}

function numberTextify(number: number) {
    if (number == 0) {
        return 'last'
    }

    if (number == 1) {
        return 'time before last'
    }

    if (number > 1) {
        return `${number + 1} times ago`
    }
}

function truthTextify(truth: boolean) {
    if (truth) return 'right';
    return 'wrong';
}

function dateTextify(createdAt: string) {
    return new Date(createdAt).toDateString();
}

function timeTextify(createdAt: string) {
    return new Date(createdAt).toTimeString();
}

export default function QuestionHistoryDisplay({
    history
}: QuestionHistoryDisplayProps) {
    if (!history) {
        return <></>;
    }

    return (
        <div className="question-history">
            {history.map((hi: any, i: number) => {
                let title = `These dots represent the last ${history.length} times you answered this question.
                This dot represents the ${numberTextify(i)} time you answered his question, and you got it ${truthTextify(hi.correct)} on: ${dateTextify(hi.createdAt)} at ${timeTextify(hi.createdAt)}`

                return (
                        <Tooltip classes={{
                            tooltip: 'tooltip-large'
                          }} key={i} title={title} aria-label={hi.createdAt}>
                            <div
                                className={
                                    "history-square history-square-" +
                                    i +
                                    " " +
                                    hi.correct
                                }
                            ></div>
                        </Tooltip>
                );
            })}
        </div>
    );
}
